import React from 'react';
import { useSelector } from 'react-redux';
import useTrackCoachOnboarding from './hooks/useTrackCoachOnboarding';

export default function CoachOnboarding() {
    const showGettingStarted = useSelector(state => {
        const loggedInUser = state.app.loggedInUser;
        const isTrialOrBasicUser = loggedInUser.isTrial || loggedInUser.isBasic;
        return isTrialOrBasicUser;
    });

    const { trackVideoPlay } = useTrackCoachOnboarding();

    if (!showGettingStarted) {
        return null;
    }

    return (
        <div className="getting-started">
            <video
                onPlay={trackVideoPlay}
                width="100%"
                style={{ backgroundColor: '#000' }}
                controls
                src="https://static.trainheroic.com/demo/coach-home-v2.mp4"
                poster="https://static.trainheroic.com/images/coach-home-v2-poster.png"
            />
            <div>
                <p>
                    Getting the most out of TrainHeroic’s powerful platform
                    tools is as easy as 1,2,3. <br />
                    <br />
                    <strong>CREATE</strong> programming <br />
                    <br />
                    <strong>CONNECT</strong> with your athletes
                    <br />
                    <br />
                    <strong>COACH</strong> them to the gains they’re chasing
                </p>
                <p>
                    Visit our{' '}
                    <a
                        href="https://www.trainheroic.com/coach-playbook-create/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        coach playbook
                    </a>{' '}
                    for step-by-step instructions as well as pro tips that’ll
                    have you using TrainHeroic like a boss in no time!
                </p>
                <p>
                    <br />
                    <br />
                    <br />
                </p>
            </div>
        </div>
    );
}
